<template>
    <v-app>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card p-4 my-5">
                        <v-carousel
                            hide-delimiters>
                            <template v-for="(item, index) in packs.length">
                                <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index">
                                    <v-row class="flex-nowrap">
                                        <template v-for="(n,i) in columns">
                                            <template v-if="(+index + i) < packs.length">
                                                <v-col :key="i">
                                                    <v-card
                                                        class="mx-auto shadows"
                                                        max-width="280">
                                                        <v-img
                                                            class="black--text"
                                                            height="200px"
                                                            src="/media/bg/panel-bg.svg">
                                                            <v-card-title
                                                                class="justify-content-center text-center py-10 white--text">
                                                                {{ packs[index + i].title }}<br/>
                                                                {{ packs[index + i].expire }} روزه
                                                            </v-card-title>
                                                        </v-img>

                                                        <v-card-text class="text--primary mx-auto">
                                                            <div class="row px-5"
                                                                 v-for="feature in packs[index+i].features"
                                                                 :key="feature.id">
                                                                <p class="text-right">{{ feature.key }}</p>
                                                                <p class="ms-auto"><span
                                                                    class="font-weight-bold">{{ feature.value }}</span>
                                                                </p>
                                                            </div>

                                                            <div class="row px-5">
                                                                <p class="text-right">قیمت پنل</p>
                                                                <p class="ms-auto"><span
                                                                    class="font-weight-bold">{{
                                                                        packs[index + i].price
                                                                    }}</span>
                                                                    ﷼ </p>
                                                            </div>

                                                        </v-card-text>

                                                        <v-card-actions>
                                                            <v-dialog
                                                                v-model="dialog[packs[index+i].id]"
                                                                persistent
                                                                :retain-focus="false"

                                                                max-width="50%"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-chip
                                                                        class="ma-2 options"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        label
                                                                        pill
                                                                    >
                                                                        ویژگی ها
                                                                    </v-chip>
                                                                </template>
                                                                <template>
                                                                    <v-card>
                                                                        <v-card-text>
                                                                            <div class="text-h5 pa-12">
                                                                                <div
                                                                                    v-for="(des, con) in packs[index + i].description.split('\n')"
                                                                                    :key="con">{{ des }}
                                                                                </div>
                                                                            </div>
                                                                        </v-card-text>
                                                                        <v-card-actions class="justify-end">
                                                                            <v-spacer></v-spacer>
                                                                            <v-btn
                                                                                color="error"
                                                                                @click="dialog[packs[index+i].id] = false"
                                                                            >بستن
                                                                            </v-btn>
                                                                        </v-card-actions>
                                                                    </v-card>
                                                                </template>
                                                            </v-dialog>
                                                            <v-chip
                                                                class="ma-2 ms-auto buy"
                                                                label
                                                                small
                                                                pill
                                                                v-on:click="buyPack(packs[index+i].id)"
                                                            >
                                                                خرید میکنم
                                                            </v-chip>

                                                        </v-card-actions>
                                                    </v-card>
                                                </v-col>
                                            </template>
                                        </template>
                                    </v-row>
                                </v-carousel-item>
                            </template>
                        </v-carousel>
                        <wallet></wallet>
                    </div>
                </div>
            </div>
        </div>
    </v-app>
</template>

<script>
import Wallet from "./wallet";

export default {
    name: "buyPanel",
    components: {Wallet},
    data: () => ({
        show: false,
        dialog: {},
        packs: [],
        openDialog: null,
    }),
    computed: {
        columns() {
            if (this.$vuetify.breakpoint.xl) {
                return 4;
            }
            if (this.$vuetify.breakpoint.lg) {
                return 3;
            }

            if (this.$vuetify.breakpoint.md) {
                return 2;
            }

            return 1;
        }
    },
    mounted() {
        this.getPacks();
    },


    methods: {
        getPacks() {
            this.requestApiGet('pack')
                .then(({data}) => {
                    this.packs = data.data;
                })
        },

        buyPack(id) {
            this.$swal({
                title: 'خرید بسته',
                text: 'آیا از خرید این بسته اطمینان دارید؟',
                icon: 'question',
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.requestApiPost(`buyPack/${id}`)
                        .then(({data}) => {
                            this.$toast.success('بسته با موفقیت خرید شد');
                            this.getPacks();
                            location.reload()
                        }).catch(({response}) => {
                      this.$toast.error(response.data.message+'');
                        if (response.status == 401) {
                            this.$toast.error(response.message);
                            this.$router.push({name: 'increaseTransactions'})
                        }
                        // if (response.status == 422)
                        //     this.$toast.error(response.message);
                    })
                }
            })
        },
    }
}
</script>

<style scoped lang="css">
.shadows {
    box-shadow: 5px 5px 5px 5px blanchedalmond;
}

.buy {
    background-color: #b958ff !important;
    box-shadow: 3px 4px 6px #b958ff;
    color: white !important;
}

.buy:hover {
    background-color: #b958ff !important;
    box-shadow: none !important;
    color: white !important;
}

.options {
    border: 1px solid #6da5ff !important;
    box-shadow: 2px 3px 4px #6da5ff;
    background-color: white !important;
    color: #6da5ff !important;
}

.options:hover {
    background-color: #6da5ff !important;
    box-shadow: none !important;
    color: white !important;
}
</style>
